import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlusCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M7.5 24.5a12 12 0 1 1 17 0 12 12 0 0 1-17 0m-1.4 1.4a14 14 0 1 0 0-19.8 14 14 0 0 0 0 19.8" />
    <path d="M17 17h6a1 1 0 0 0 0-2h-6V9a1 1 0 0 0-2 0v6H9a1 1 0 1 0 0 2h6v6a1 1 0 0 0 2 0z" />
  </svg>
);
const ForwardRef = forwardRef(IconPlusCircleOutlineSVG);
ForwardRef.displayName = "IconPlusCircleOutline";
export { ForwardRef as IconPlusCircleOutline };
